mutation createValuation($input: CreateValuationByAgentInput!) {
  valuation: createValuationByAgent(input: $input) {
    id
    status
    createdAt
  }
}
